export const meals = [
  {
    id: '2',
    name: 'RO',
    fullname: 'Room Only',
    russian: 'Без питания',
    russianfull: 'RO - Без питания',
  },
  {
    id: '3',
    name: 'BB',
    fullname: 'Bed&Breakfast',
    russian: 'Только завтрак',
    russianfull: 'BB - Только завтрак',
  },
  {
    id: '4',
    name: 'HB',
    fullname: 'Half Board',
    russian: 'Завтрак, Ужин',
    russianfull: 'HB - Завтрак, Ужин',
  },
  {
    id: '5',
    name: 'FB',
    fullname: 'Full Board',
    russian: 'Полный Пансион',
    description: 'Завтрак, Обед, Ужин',
    russianfull: 'FB - Полный Пансион',
  },
  {
    id: '7',
    name: 'AI',
    fullname: 'All Inclusive',
    russian: 'Все Включено',
    russianfull: 'AI - Все Включено',
  },
  {
    id: '9',
    name: 'UAI',
    fullname: 'Ultra All Inclusive',
    russian: 'Ультра Все Вкл',
    russianfull: 'UAI - Ультра Все Включено',
  },
];

export default meals;
